// hasDelay — pure detection of whether a flight leg is delayed.
//
// Extracted verbatim from `FlightLookup.js` (module-level `hasDelay` helper) as
// part of the behavior-preserving refactor (issue #240). A leg is considered
// delayed when both an estimated and a scheduled time exist and they differ.
//
// Totality preserved exactly: any missing value yields `false` via the truthiness
// checks, matching the source. Always returns a boolean.
//
// React-free and side-effect-free.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

/**
 * Detects whether a flight leg is delayed.
 *
 * @param {*} estimated - The estimated time value (may be missing).
 * @param {*} scheduled - The scheduled time value (may be missing).
 * @returns {boolean} `true` when an estimated time exists and differs from scheduled.
 */
export function hasDelay(estimated, scheduled) {
  return Boolean(estimated && scheduled && estimated !== scheduled);
}

export default hasDelay;
